var render = function render(){
  var _vm$selectedUser;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Poptip', {
    attrs: {
      "placement": "right"
    },
    on: {
      "on-popper-show": function ($event) {
        return _vm.searchUserShow('search-user');
      }
    },
    model: {
      value: _vm.searchUserPopVisible,
      callback: function ($$v) {
        _vm.searchUserPopVisible = $$v;
      },
      expression: "searchUserPopVisible"
    }
  }, [_vm.selectedUser ? _c('div', {
    staticClass: "user-select"
  }, [_vm._v(" " + _vm._s((_vm$selectedUser = _vm.selectedUser) === null || _vm$selectedUser === void 0 ? void 0 : _vm$selectedUser.name) + " ")]) : _c('div', {
    staticClass: "user-select",
    staticStyle: {
      "font-size": "18px",
      "cursor": "pointer"
    }
  }, [_vm._v(" 选择业务员 ")]), _c('template', {
    slot: "content"
  }, [_c('Row', [_c('Input', {
    ref: "search-user",
    attrs: {
      "placeholder": "搜索用户",
      "size": "small"
    },
    model: {
      value: _vm.searchUserText,
      callback: function ($$v) {
        _vm.searchUserText = $$v;
      },
      expression: "searchUserText"
    }
  })], 1), _c('div', {
    staticClass: "user-area"
  }, _vm._l(_vm.simpleUserList.filter(function (v) {
    return v.name.includes(_vm.searchUserText);
  }), function (user) {
    var _vm$selectedUser2;
    return _c('div', {
      staticClass: "user-card"
    }, [((_vm$selectedUser2 = _vm.selectedUser) === null || _vm$selectedUser2 === void 0 ? void 0 : _vm$selectedUser2._id) === user._id ? _c('div', {
      staticStyle: {
        "color": "blue"
      },
      on: {
        "click": function ($event) {
          return _vm.selectUser(null);
        }
      }
    }, [_vm._v(" " + _vm._s(user.name) + " ")]) : _c('div', {
      on: {
        "click": function ($event) {
          return _vm.selectUser(user);
        }
      }
    }, [_vm._v(" " + _vm._s(user.name) + " ")])]);
  }), 0)], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }